import type React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDiary } from "@/hooks/useDiary";
import { diaryService } from "@/services/diaryService";
import DiaryForm from "./components/DiaryForm";
import type { DiaryFormData } from "@/types/diary";

const DiaryFormPage: React.FC = () => {
	const { diaryId } = useParams<{ diaryId?: string }>();
	const navigate = useNavigate();
	const { diary, loading, error } = useDiary(diaryId);

	if (loading) {
		return (
			<div className="container mx-auto px-4 py-8">
				<p className="text-center text-gray-500">読み込み中...</p>
			</div>
		);
	}

	if (error) {
		return (
			<div className="container mx-auto px-4 py-8">
				<p className="text-center text-red-500">
					エラーが発生しました: {error.message}
				</p>
			</div>
		);
	}

	const handleSubmit = async (formData: DiaryFormData) => {
		try {
			const diaryInput = {
				title: formData.title,
				content: formData.content,
			};

			if (diaryId) {
				await diaryService.updateDiary(diaryId, diaryInput);
			} else {
				await diaryService.createDiary(diaryInput);
			}
			navigate("/webapp/diary");
		} catch (err) {
			console.error("日記の保存に失敗しました:", err);
			throw err;
		}
	};

	const initialData = diary
		? {
				title: diary.title,
				content: diary.content,
				date: new Date(diary.createdAt).toISOString().split("T")[0],
			}
		: undefined;

	return (
		<div className="container mx-auto px-4 py-8">
			<h1 className="text-3xl font-bold mb-6">
				{diaryId ? "日記を編集" : "新しい日記"}
			</h1>
			<DiaryForm initialData={initialData} onSubmit={handleSubmit} />
		</div>
	);
};

export default DiaryFormPage;
